import type { ColDef } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { Button, Modal, Table, message, Popconfirm } from 'antd';
import type { ColumnsType } from "antd/es/table";
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { RowFiling, FetchFilingRequest, FilingProps, FilingData, ExcelFilingRequest } from '../constant';
import { FectchFiling } from "../api/FetchFiling";
import { convertToRowFiling, isFetchFilingResponse, parsingCarrier } from '../common';
import DOMPurify from 'dompurify';
import ReverseButtonComponent from '../components/ReverseButtonComponent'
import { ReverseFiling } from "../api/cudFiling";
import { DownloadExcelFiling } from '../api/exceloutFiling';
import { FileExcelOutlined } from '@ant-design/icons';
import CustomLoadingOverlay from '../components/CustomLoadingOverlay';

import {
    AllCommunityModule,
    CheckboxEditorModule,
    ClientSideRowModelModule,
    ModuleRegistry,
    themeQuartz,
    ValidationModule
} from "ag-grid-community";
import moment from 'moment';

ModuleRegistry.registerModules([AllCommunityModule, CheckboxEditorModule, ClientSideRowModelModule, ValidationModule]);

const HeaderStyle: React.CSSProperties = {
    height: '50px',
};

const searchhelpStyle: React.CSSProperties = {
    minHeight: '100px',
    maxHeight: '400px',
    overflowY: 'auto'
};

  export interface SearchProps{
    user: {[key: string]: string},
    carriers: string[],
    users: { [key: string]: string },
    slcodes: { [key: string]: string },
    isSelected: boolean
    latesearch: string
    setLateSearch: (policynumber: string) => void
    latelicense: string
    setLateLicense: (licensenumber: string) => void
  }

const SearchFiling: React.FC<SearchProps> = ({ user, slcodes, latesearch, setLateSearch, latelicense, setLateLicense }) => {

    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState<RowFiling[]>([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [carrierrows, setCarrierrows] = useState<any[]>([]);
    const [searchword, setSearchWord] = useState<string>("")
    const [isSearchHelpModal, setIsSearchHelpModal] = useState(false);
    const [searchhelp_html, setSearchHelp_html] = useState<string>('');
    const [filingList, setFilingList] = useState<FilingData[]>([]);
    const listRef = useRef(filingList);

    const [colDefs, setColDefs] = useState<ColDef[]>([
        {
            headerClass: 'reverse-header',
            headerName: "",
            field: "reverse",
            editable: false,
            width: 30,
            cellRenderer: (params: any) => (
                <ReverseButtonComponent
                    api={params.api}
                    node={params.node}
                    onReverseButton={onReverseFiling}
                />
            ),
        },
        { headerName: 'Filing ID', field: "id", width: 100, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: 'Late?', field: "late", width: 70, resizable: true },
        { headerName: 'Policy Number', field: "policynumber", width: 150, resizable: true, cellStyle: { textAlign: "left" }, cellClass: 'selectable-cell' },
        { headerName: 'Trans Type', field: "transType", width: 60, resizable: true },
        { headerName: 'Insured Name', field: "insuredName", width: 200, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: 'Insured City, State Zip', field: "insuredAddress", width: 220, resizable: true, cellStyle: { textAlign: "left" } },
        {
            headerName: 'Transaction Effective Date', field: "transEffectiveDate", width: 100, resizable: true,
            valueFormatter: (params) => {
                const value = params.value;
                return value ? moment(value).format('MM/DD/YYYY') : '';
            },
        },
        {
            headerName: 'Transaction Date', field: "transDate", width: 100, resizable: true,
            valueFormatter: (params) => {
                const value = params.value;
                return value ? moment(value).format('MM/DD/YYYY') : '';
            },
        },
        { headerName: 'Class Code', field: "slCode", width: 270, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: 'Premium', field: "premium", width: 90, resizable: true, cellStyle: { textAlign: "right" } },
        { headerName: 'Policy Fees', field: "policyFee", width: 70, resizable: true, cellStyle: { textAlign: "right" } },
        { headerName: 'State Tax (3%)', field: "tax", width: 80, resizable: true, editable: false, cellStyle: { textAlign: "right" } },
        { headerName: 'Stamping Fee (0.2%)', field: "stampingFee", width: 90, resizable: true, editable: false, cellStyle: { textAlign: "right" } },
        { headerName: 'Late Fee', field: 'latefee', width: 80, editable: false, cellStyle: { textAlign: "right" } },
        { headerName: 'Carriers', field: 'carriers', width: 800, editable: false, cellStyle: { textAlign: "left" } },
    ]);

    useEffect(() => {
        listRef.current = filingList;
    }, [filingList]);

    useEffect(() => {
        console.log(`latesearch  = ${latesearch}`)
        if (latesearch !== "") {
            setRowData([]);
            setLoading(true);

            const filingrequest: FetchFilingRequest = {
                userid: 0,
                posted: "Y",
                searchWords: latesearch,
                licenseNumber: user.userType !== '0' ? latelicense : user.licenseNumber
            }

            setLateSearch("")
            setLateLicense(user.licenseNumber)
            FectchFiling(filingrequest)
                .then((fetchFilingResult) => {
                    if (fetchFilingResult.success) {
                        //message.success({ content: 'Success to search the Filings', key: 'SearchStatus', duration: 2 });
                        if (isFetchFilingResponse(fetchFilingResult)) {
                            setFilingList(fetchFilingResult.fetchedList)
                            setRowData(convertToRowFiling(fetchFilingResult.fetchedList, slcodes))
                        }
                    }
                    else {
                        if ("errorMsg" in fetchFilingResult) {
                            message.error({ content: 'Failed to search the Filings', key: 'SearchStatus', duration: 2 });
                            //message.error(fetchFilingResult.errorMsg)
                        }
                    }
                })
                .catch((error) => {
                    console.error("An error occurred:", error.message);
                    return
                })
                .finally(() => {
                    setLoading(false)
                });
        }
    }, []);

    const onReverseFiling = (rowIndex: number) => {
        message.loading({ key: 'reverseFiling', content : 'Reversing Filing...', duration: 0});
        ReverseFiling(listRef.current[rowIndex].id, user.licenseNumber)
            .then((result) => {
                if (result.success) {
                    message.success({key: 'reverseFiling', content : result.errorMsg})
                }
                else {
                    message.error({key: 'reverseFiling', content : result.errorMsg})
                }
            })
            .catch((error) => {
                console.error("An error occurred:", error.message);
                return
            });
    }

    const handleSearchClick = () => {

        setRowData([]);
        setLoading(true);

        const filingrequest: FetchFilingRequest = {
            userid: 0,
            posted: "Y",
            searchWords: searchword,
            licenseNumber: user.licenseNumber
        }

        FectchFiling(filingrequest)
            .then((fetchFilingResult) => {
                if (fetchFilingResult.success) {
                    //message.success({ content: 'Success to search the Filings', key: 'SearchStatus', duration: 2 });
                    if (isFetchFilingResponse(fetchFilingResult)) {
                        setFilingList(fetchFilingResult.fetchedList)
                        setRowData(convertToRowFiling(fetchFilingResult.fetchedList, slcodes))
                    }
                }
                else {
                    if ("errorMsg" in fetchFilingResult) {
                        message.error({ content: 'Failed to search the Filings', key: 'SearchStatus', duration: 2 });
                        //message.error(fetchFilingResult.errorMsg)
                    }
                }
            })
            .catch((error) => {
                console.error("An error occurred:", error.message);
                return
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const showSearchHelpModal = () => {
        const fetchSearchHelpHtml = async () => {
            try {
                const response = await fetch('/html/searchhelp.html');
                if (response.ok) {
                    const htmlContent = await response.text();
                    setSearchHelp_html(DOMPurify.sanitize(htmlContent));
                } else {
                    console.error('Failed to load aboutus.html');
                }
            } catch (error) {
                console.error('Error fetching aboutus.html:', error);
            }
        };

        fetchSearchHelpHtml()
        setIsSearchHelpModal(true);
    }

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchWord(e.target.value)
    }

    const defaultColDef = useMemo<ColDef>(() => {
        return {
            headerClass: 'custom-header',
            sortable: false
        };
    }, []);

    const myTheme = themeQuartz
        .withParams({
            headerColumnBorder: { color: 'gray' },
            headerColumnBorderHeight: '90%',
        });

    const onCellDoubleClicked = (params: any) => {
        if (params.colDef.field === "carriers") {
            showModal(params.data.carriers)
        }
    };

    const showModal = (data: string) => {
        const initrow = data === "" ? [] : data
            .split(" / ")
            .map((item, index) => {
                console.log(item)
                const match = parsingCarrier(item)
                if (match) {
                    return { key: index, carrier: match[0], percent: match[1] };
                }
                return [];
            })

        setCarrierrows(initrow)
        setIsModalVisible(true);
    }

    const handleCancel = () => {
        setIsModalVisible(false);
        setCarrierrows([]);
    }

    const handleSearchHelpCancel = () => {
        setIsSearchHelpModal(false);
    }

    const handleOk = () => {

    };

    const DownloadFilingExcel = (bshort: boolean) => {
        if (rowData.length === 0)
            return

        const excelrequest: ExcelFilingRequest = {
            fetchRequest: {
                userid: 0,
                posted: "Y",
                searchWords: searchword,
                licenseNumber: user.licenseNumber
            },
            bShort: bshort
        }
        message.loading({ content: 'Excel File Downloading...', key: 'downloadexcel', duration: 0 });
        DownloadExcelFiling(excelrequest)
            .then((excelFilingResult) => {
                if (excelFilingResult.success) {
                    message.success({ content: excelFilingResult.errorMsg, key: 'downloadexcel', duration: 2 })
                }
                else {
                    message.error({ content: excelFilingResult.errorMsg, key: 'downloadexcel', duration: 2 })
                }
            })
            .catch((error) => {
                console.error("An error occurred:", error.message);
                return
            });

    }

    const ShortFormExcel = () => {
        DownloadFilingExcel(true)
    }

    const LongFormExcel = () => {
        DownloadFilingExcel(false)
    }

    interface DataType {
        key: string;
        carrier: string;
        percent: number;
    }
    const columns: ColumnsType<DataType> = [
        {
            title: "Carrier",
            dataIndex: "carrier",
            key: "carrier",
            width: "400px",
            align: "center"
        },
        {
            title: "Percent",
            dataIndex: "percent",
            key: "percent",
            width: "60px",

        },
    ];
    return (
        <div style={{ height: '100%' }} className='text-style'>
            <div className="flex justify-between items-center bg-gray-100" style={HeaderStyle}>
                <div className='flex flex-row ml-10'>
                    <div className='mt-2'><span>search : &nbsp;</span></div>
                    <div>
                        <input type="text" className='mt-1 register-input-style' onChange={handleSearchChange}></input>
                        <Button size='small' type='primary' className='small-button' onClick={handleSearchClick}>Search</Button>
                        <Button size='small' type='primary' className='small-button' onClick={showSearchHelpModal}>Help</Button>
                    </div>
                </div>

                <Popconfirm
                    placement="bottom"
                    overlayStyle={{ width: 300, height: 100, fontSize: 12 }}
                    icon={null}
                    title="Long or Short Form?"
                    description="The short form is ideal for printing but does not include full details, the long form includes all details about the filing but does not print well."
                    okButtonProps={{ size: "small", style: { width: 80, fontSize: 12, backgroundColor: 'green', color: 'white' } }}
                    cancelButtonProps={{ size: "small", style: { width: 80, fontSize: 12, backgroundColor: 'green', color: 'white' } }}
                    okText="Short Form"
                    cancelText="Long Form"
                    onConfirm={ShortFormExcel}
                    onCancel={LongFormExcel}
                >
                    <Button
                        variant="outlined"
                        type='primary'
                        icon={<FileExcelOutlined className='icon-style' />}
                        className='ml-0.5, mr-40 button-style'>
                        Save to Excel
                    </Button>
                </Popconfirm>
            </div>
            <div className="ag-theme-alpine tab-container">
                <AgGridReact
                    rowData={rowData}
                    columnDefs={colDefs}
                    theme={myTheme}
                    defaultColDef={defaultColDef}
                    headerHeight={35}
                    rowHeight={25}
                    onCellDoubleClicked={onCellDoubleClicked}
                    loading={loading}
                    loadingOverlayComponent={CustomLoadingOverlay}
                    loadingOverlayComponentParams={{ message: "Searching..." }}
                />
            </div>

            <Modal
                title={
                    <div className='text-style' style={{ textAlign: "center", fontWeight: "bold" }}>
                        Carriers
                    </div>
                }
                className='text-style'
                open={isModalVisible}
                onCancel={handleCancel}
                onOk={handleOk}
                width={600}
                height={400}
                footer={null}
            >
                <Table
                    columns={columns}
                    dataSource={carrierrows}
                    pagination={false}
                    rowKey="key"
                />
            </Modal>
            <Modal
                title={
                    <div className='text-style' style={{ textAlign: "center", fontWeight: "bold" }}>
                        Search Help...
                    </div>
                }
                className='text-style'
                open={isSearchHelpModal}
                width={600}
                height={500}
                onCancel={handleSearchHelpCancel}
                footer={null}
            >
                <div style={searchhelpStyle}>
                    <div dangerouslySetInnerHTML={{ __html: searchhelp_html }} />
                </div>
            </Modal>
        </div>
    )
}

export default SearchFiling;